<button
  class="btn {{buttonClass}} {{disabled ? 'disabled' : ''}}"
  (click)="onClick()"
  role="button"
  aria-pressed="true"
  [attr.disabled]="disabled ? 'disabled' : null">

  @if (primaryIcon && !loading) {
    @if (!stacked) {
      @if (primaryIcon.includes('.')) {
        <img alt="" class="btn-icon" height="50" width="50" ngSrc="{{primaryIcon}}">
      } @else {
        <i class="btn-icon {{ primaryIcon }}"></i>
      }
    } @else {
      <span class="btn-icon fa-stack fa-2x">
        <i class="fa-stack-2x {{ primaryIcon }}"></i>
        <i class="fa-stack-1x {{ secondaryIcon }}"></i>
      </span>
    }
  }

  <app-spinner [loading]="loading" class="btn-icon"></app-spinner>

  <span class="btn-text {{ (!primaryIcon || alwaysShowText) ? '' : 'd-none d-md-block' }}">{{ buttonText() }}</span>
</button>
